import { render, staticRenderFns } from "./talentDetails.vue?vue&type=template&id=0fc6c896&"
import script from "./talentDetails.vue?vue&type=script&lang=js&"
export * from "./talentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports